import axios from './axios';

export const mobileVerification = (data: { uid: string; phoneNumber: string }) => {
  return axios
    .post<any>('/stages/ksa/application/set-person-phone-number', data)
    .then((res) => res.data);
};
